export const OPEN_CATEGORY = 'OPEN_CATEGORY';
export const REQUEST_APPS_BY_CATEGORY = 'REQUEST_APPS_BY_CATEGORY';
export const RECEIVE_APPS_BY_CATEGORY = 'RECEIVE_APPS_BY_CATEGORY';

export const RECEIVE_APPS_BY_TYPE = 'RECEIVE_APPS_BY_TYPE';
export const REQUEST_APPS_BY_TYPE = 'REQUEST_APPS_BY_TYPE';

export const REQUEST_CATEGORIES = 'REQUEST_CATEGORIES';
export const RECEIVE_CATEGORIES = 'RECEIVE_CATEGORIES';

export const REQUEST_COLLECTION = 'REQUEST_COLLECTION';
export const RECEIVE_COLLECTION = 'RECEIVE_COLLECTION';
export const REQUEST_COLLECTION_APPS = 'REQUEST_COLLECTION_APPS';
export const RECEIVE_COLLECTION_APPS = 'RECEIVE_COLLECTION_APPS';

export const OPEN_APP = 'OPEN_APP';
export const REQUEST_APP = 'REQUEST_APP';
export const RECEIVE_APP = 'RECEIVE_APP';

export const SET_SEARCH_QUERY = 'SET_REQUEST_SEARCH';
export const REQUEST_SEARCH = 'REQUEST_SEARCH';
export const RECEIVE_SEARCH = 'RECEIVE_SEARCH';
export const RECEIVE_POPULAR_APPS = 'RECEIVE_POPULAR_APPS';
export const REQUEST_POPULAR_APPS = 'REQUEST_POPULAR_APPS';

export const REQUEST_ALL_REVIEWS = 'REQUEST_ALL_REVIEWS';
export const RECEIVE_ALL_REVIEWS = 'RECEIVE_ALL_REVIEWS';

export const RECEIVE_EXPERIMENTS = 'RECEIVE_EXPERIMENTS';
export const CHANGE_VERTICAL = 'CHANGE_VERTICAL';
export const SET_MARKET = 'SET_MARKET';
export const SET_QUERY = 'SET_QUERY';
export const SET_ENVIRONMENT = 'SET_ENVIRONMENT';
export const SET_LANG = 'SET_LANG';
export const ERROR_PAGE = 'ERROR_PAGE';

export const POPUP_SHOW = 'POPUP_SHOW';
export const POPUP_HIDE = 'POPUP_HIDE';



// WEBPACK FOOTER //
// ./actions/action-types.js